<template>
  <v-card>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-container>
        <v-layout row wrap>
          <!-- <v-flex
                        xs3
                        md3
                        class="text-lg-left"
                    >
                        <v-text-field
                            v-model="name"
                            label="Nome"
                            class="purple-input"
                            @keyup.enter="_search"
                        />
                    </v-flex> -->
          <v-flex xs6 md2 class="text-lg-left">
            <v-text-field
              v-model="email"
              label="Email"
              class="purple-input"
              @keyup.enter="_search"
            />
          </v-flex>
          <v-flex xs6 md2 class="text-lg-left">
            <v-text-field
              v-model="phone"
              label="Telefone"
              class="purple-input"
              @keyup.enter="_search"
            />
          </v-flex>
          <v-flex xs6 md2 class="text-lg-left">
            <v-text-field
              v-model="cpf"
              label="CPF"
              class="purple-input"
              @keyup.enter="_search"
            />
          </v-flex>
          <v-flex xs6 md2 class="text-lg-left">
            <v-text-field
              v-model="installation_number"
              label="Unidade Consumidora"
              class="purple-input"
              @keyup.enter="_search"
            />
          </v-flex>
          <v-flex xs6 md2 class="text-lg-left">
            <v-btn
              color="success"
              outline
              small
              slot="start"
              @click="_search"
              :disabled="!valid || loading"
              :loading="loading"
            >
              <v-icon left>search</v-icon>Buscar
            </v-btn>
          </v-flex>
          <v-flex xs6 md2 class="text-lg-left">
            <v-btn
              color="tertiary"
              small
              outline
              slot="start"
              @click="_clear"
              :disabled="!valid || loading"
            >
              <v-icon left>clear</v-icon>Limpar
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </v-card>
</template>
<script>
import {
  mapActions, //, mapGetters
  mapState,
  mapMutations,
} from "vuex";

export default {
  data: () => ({
    consumerunits: [],
    user: {},
    email: "",
    phone: "",
    cpf: "",
    installation_number: "",
    valid: false,
  }),
  computed: {
    ...mapState("cs", ["loading", "billing", "filter"]),
    // filter () {
    //     if(this.$store.state && this.$store.state.cs && this.$store.state.cs.filter) return this.$store.state.cs.filter
    //     else return null
    // },
    // loading () {
    //     if(this.$store.state && this.$store.state.cs && this.$store.state.cs.loading) return this.$store.state.cs.loading
    //     else return false
    // },
    // billing () {
    //     if(this.$store.state && this.$store.state.cs && this.$store.state.cs.billing) return this.$store.state.cs.billing
    //     else return {}
    // }
  },
  mounted() {
    //   console.log('email: ', this.$route.query.email)
    if (
      this.$route.query &&
      (this.$route.query.email || this.$route.query.installation_number)
    ) {
      let params = {};
      if (this.$route.query.email) {
        params.email = this.$route.query.email;
        this.email = this.$route.query.email;
      } else if (this.$route.query.installation_number) {
        params.installation_number = this.$route.query.installation_number;
        this.installation_number = this.$route.query.installation_number;
      }
      this.setFilter(params);
      this.getUserByParams(params);
    }
    if (this.filter) {
      this.email = this.filter.email || "";
      this.cpf = this.filter.cpf || "";
      this.phone = this.filter.phone || "";
      this.installation_number = this.filter.installation_number || "";
    }
  },
  watch: {
    filter(val) {
      this.email = val.email;
      this.cpf = val.cpf;
      this.phone = val.phone;
      this.installation_number = val.installation_number;
    },
  },
  methods: {
    ...mapMutations("cs", ["setFilter"]),
    ...mapActions("cs", ["getUserByParams", "resetFilter"]),
    _search() {
      this.resetFilter();
      this.loading_search = true;
      let params = {};
      if (this.email) {
        params.email = this.email;
      } else if (this.phone) {
        params.phone = this.phone;
      } else if (this.cpf) {
        params.cpf = this.cpf;
      } else if (this.installation_number) {
        params.installation_number = this.installation_number;
      }
      this.setFilter(params);
      this.getUserByParams(params);
    },
    _clear() {
      this.email = "";
      this.cpf = "";
      this.phone = "";
      this.installation_number = "";
      this.resetFilter();
      return;
    },
  },
  beforeDestroy() {},
};
</script>
